// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1006":"5062b3b2","61094":"5062b3b2","87304":"e59e2fc3"}[chunkId] + ".chunk.css";
};